enum AnnotationFlattenDialogFields {
	PAGES = "pages"
}

export default AnnotationFlattenDialogFields;